var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1SmartphoneVibration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v12h-4V32h4zM57 51h4V25h-4v26zm-5-31v38a4 4 0 01-4 4H28a4 4 0 01-4-4V20a4 4 0 014-4h20a4 4 0 014 4zm-4 0H28v38h20V20zM37.5 53.5a2 2 0 100-4 2 2 0 000 4zM15 51h4V25h-4v26zm-7-7h4V32H8v12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Smartphone_vibration.4c41d780.svg";
export { SvgG1SmartphoneVibration as ReactComponent };